import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveSpace } from 'spaces/store/selectors';
import Button from 'base/components/Button';
import MainTitle from 'base/components/Title3';
import ErrorBoundary from 'base/components/ErrorBoundary';
import { isValidToken } from 'auth/util/jwt';
import { FullScreenModalHeader } from 'modal/components/ModalHeader/ModalHeader';
import PdfViewer from '../../components/PdfViewer/PdfViewer';
import {
  getActiveDocument, getActiveDocumentId, getIsLoading, getHasError,
} from '../../store/documents/selectors';
import { downloadDocument, fetchDocument } from '../../store/documents/actions';


class DocumentPage extends React.Component {
  componentDidMount() {
    const { fetchDocument, id } = this.props;
    fetchDocument(id);
  }

  componentDidUpdate(prevProps) {
    const { fetchDocument, id } = this.props;
    if (prevProps.id !== id) {
      fetchDocument(id);
    }
  }

  handleDownload = () => {
    const { document, downloadDocument } = this.props;
    downloadDocument(document);
  };

  render() {
    const { document, isLoading, hasError } = this.props;

    const viewerIsEnabled = !hasError
        && document
        && !process.env.REACT_APP_PSPDFKIT_IS_MAINTENANCE_MODE
        && (document.file.mime === 'application/pdf' || document.file.pdfCopyFilename)
        && document.psPdfKitAccessToken
        && isValidToken(document.psPdfKitAccessToken);

    const downloadMessage = (
      <div>
        {process.env.REACT_APP_PSPDFKIT_IS_MAINTENANCE_MODE
          ? (
            <div>
                The file viewer is currently undergoing maintenance work
                and will be back online soon.
              {' '}
              <br />
              <br />
                In the meantime, you can download the document below.
              <br />
              <br />
            </div>
          )
          : (
            <div>
                The file viewer cannot display this document.
                Click the button below to download.
              <br />
              <br />
            </div>
          )}
        <Button variant="primary" onClick={this.handleDownload}>
            Download document
        </Button>
      </div>
    );

    const content = viewerIsEnabled
      ? (
        <ErrorBoundary fallback={() => downloadMessage}>
          <PdfViewer
            documentId={document.id.toString()}
            psPdfKitAccessToken={document.psPdfKitAccessToken}
            style={{ width: 'auto' }}
            onDownloadOriginal={this.handleDownload}
            fileName={document.file.mime === 'application/pdf'
              ? document.file.filename
              : document.file.pdfCopyFilename}
          />
        </ErrorBoundary>
      )
      : downloadMessage;

    return (
      <>
        <FullScreenModalHeader>
          <MainTitle>
            {document ? document.name : 'Loading..'}
          </MainTitle>
        </FullScreenModalHeader>
        {isLoading ? 'Loading...' : content}
      </>
    );
  }
}

DocumentPage.propTypes = {
  document: PropTypes.objectOf(PropTypes.any),
  downloadDocument: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  fetchDocument: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
};
DocumentPage.defaultProps = {
  document: null,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
  document: getActiveDocument(state),
  id: getActiveDocumentId(state),
  isLoading: getIsLoading(state),
  hasError: getHasError(state),
});

const mapDispatchToProps = {
  downloadDocument,
  fetchDocument,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentPage);
